module.exports = __webpack_public_path__ + "img/Orange.09e8879c.svg";